module.exports = __webpack_public_path__ + "static/media/keyman-db-banner-short.20bda602.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyman-db-banner-short.png
// module id = 1288
// module chunks = 1